export const HeaderIcons = {
    cartNcall: {
        showBackButton: true,
        showSearch: false,
        showCart: true,
        showCallExpert: true,
        showEmailUs: true,
        showRedToMintpro: true,
    },
    hiddenLogo: {
        showBackButton: true,
        showLogo: false,
        showCart: true,
        showCallExpert: true,
        showEmailUs: true,
        showRedToMintpro: true
    },
    visibleLogo: {
        showBackButton: false,
        showLogo: true,
        showCart: true,
        showCallExpert: true,
        showEmailUs: true,
        showRedToMintpro: true,
    },
    hideRedToMintpro: {
        showBackButton: true,
        showSearch: false,
        showCart: true,
        showCallExpert: true,
        showEmailUs: true,
        showRedToMintpro: false
    },
    showBackToHomeCTA: {
        showBackButton: true,
        showSearch: false,
        showCart: false,
        showRedToMintpro: false,
        showBackToHome: true,
        showCallExpert: true,
        showEmailUs: true,
    },
    showAllIcon: {
        showBackButton: true,
        showSearch: true,
        showCart: true,
        showRedToMintpro: true,
        showCallExpert: true,
        showEmailUs: true,
    },
    calculatorHeader:{
        showBackButton: false,
        showLogo: true,
        showCart: false,
        showCallExpert: false,
        showEmailUs: false,
        showRedToMintpro: true,
        showYourAdvisorSection: true,
    },
    homeHeader:{
        showRedToMintpro: true,
        showBackButton: false,
        showLogo: true,
        showCart: true,
        showCallExpert: true,
        showEmailUs: true,
        showYourAdvisorSection: false,
        showCustomisedHomeHeader: true,
        iconBackToMintProWeb: true,
        showCustomerCount: true
    },
    showCustomerCountnAUM: {
        showBackButton: true,
        showLogo: false,
        showCart: true,
        showCallExpert: true,
        showEmailUs: true,
        showRedToMintpro: true,
        showCustomerCount: true,
    },
    showOnlyBackButton:{
        showBackButton: true,
        showLogo: false,
        showSearch: false,
        showCallExpert: false,
        showEmailUs: false,
    },
}